function PageNotFound() {
  return (
    <div className="dummy">
      <p>Wrong endpoint :(</p>
    </div>
  );
}

export default PageNotFound;
